import BaseLoading from '@/src/components/helpers/base-loading/base-loading'
import CreateElements from '@/src/components/helpers/create-elements/create-elements'
import React from 'react'
import styles from './styles.module.scss'

export default function LoadingHalfFlavors() {
    return (
        <BaseLoading>
            <div className={styles.products}>
                <CreateElements quantity={5}>
                    <div className={styles.product}>
                        <aside className={styles.imageArea}></aside>
                        <div className={styles.descriptionArea}>
                            <aside style={{ height: '10px', width: '100px' }}></aside>
                            <aside style={{ height: '10px', width: '80%' }}></aside>
                            <aside style={{ height: '10px', width: '40px' }}></aside>
                        </div>
                    </div>
                </CreateElements>
            </div>
        </BaseLoading>
    )
}
